import { useLocation } from "react-router-dom";
import { pathNames } from "../../data/dashboard/pathData";

const useCurrentPath = () => {
  const { pathname } = useLocation();

  // get all routes from url ==> [route1,route2,route3]
  const pathParts = pathname.split("/").filter(Boolean);

  // route1 > route2 > route3
  const route1 =
    pathname === "/dashboard"
      ? pathNames[0]
      : pathNames?.find((path) => path.route === pathParts[1]);
  const route2 = route1?.children?.find((path) => path.route === pathParts[2]);
  const route3 = route2?.children?.find((path) => path.route === pathParts[3]);

  return { route1, route2, route3 };
};

export default useCurrentPath;
